import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FindCompaniesComponent } from './companies/find-companies.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FindContactsComponent } from './contacts/find-contacts.component';
import { FindUsersComponent } from './users/find-users.component';
import { FindProjectsComponent } from './projects/find-projects.component';
import { FindEventsComponent } from './events/find-events.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [
    FindCompaniesComponent,
    FindContactsComponent,
    FindUsersComponent,
    FindProjectsComponent,
    FindEventsComponent
  ],
  exports: [
    FindCompaniesComponent,
    FindContactsComponent,
    FindUsersComponent,
    FindProjectsComponent,
    FindEventsComponent
  ]
})
export class DropdownsModule { }



// WEBPACK FOOTER //
// ./client/app/shared/dropdowns/dropdowns.module.ts